import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CargoManifestDelete from 'components/CargoManifestDelete';

import { openBaseModal } from 'redux/modules/job-detail/effects';

import { getJobDetailData } from 'redux/modules/job-detail/selectors';

const CargoManifestDeleteSubmodal = ({ item, openBaseModal, params }) => {
  if (!item) {
    return null;
  }

  const { stop_id, cargo_id } = params;
  const stop = stop_id && item.stops[stop_id];
  const cargoManifest = stop && stop.cargo_manifests[cargo_id];

  return (
    <CargoManifestDelete
      show={true}
      cargoManifest={cargoManifest}
      journey={item}
      stopId={stop_id}
      onClose={openBaseModal}
      onDelete={openBaseModal}
    />
  );
};

CargoManifestDeleteSubmodal.propTypes = {
  item: PropTypes.object,
  openBaseModal: PropTypes.func,
  params: PropTypes.object,
};

const actionCreators = {
  openBaseModal,
};

export default connect((state) => {
  return {
    item: getJobDetailData(state),
  };
}, actionCreators)(CargoManifestDeleteSubmodal);
